import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getIsDarkTheme } from '../reducers';

const ThemeSwitcher = () => {
  const isDarkTheme = useSelector(getIsDarkTheme) || false;
  const { pathname = '' } = window.location || {};

  useEffect(() => {
    const body = document.querySelector('body');
    const colorSchemeTag = document.querySelector('meta[name="color-scheme"]');

    if (isDarkTheme && !body.classList.contains('dark')) {
      body.classList.add('dark');

      if (pathname !== '/billing') {
        colorSchemeTag.setAttribute('content', 'dark');
      }
    }

    if (!isDarkTheme && body.classList.contains('dark')) {
      body.classList.remove('dark');

      if (pathname !== '/billing') {
        colorSchemeTag.setAttribute('content', 'light');
      }
    }

    if (
      pathname === '/billing' &&
      colorSchemeTag.getAttribute('content') === 'dark'
    ) {
      colorSchemeTag.setAttribute('content', 'light');
    }
  }, [isDarkTheme, pathname]);

  return '';
};

export default ThemeSwitcher;
